import React from "react";
import { Box, Typography } from "@mui/material";
import "./NoPackageAvailable.scss";

interface NoPackageAvailableProps {
  message: string;
}

const NoPackageAvailable: React.FC<NoPackageAvailableProps> = ({ message }) => {
  return (
    <Box className="noPackageFound">
      <Typography className="noPackageFoundText">{message}</Typography>
    </Box>
  );
};

export default NoPackageAvailable;
